import { MapPin, Users, Sparkles, Settings2 } from "lucide-react";
import { WHY_CHOOSE_US } from "@/lib/siteData";

const ICONS = [MapPin, Users, Sparkles, Settings2];

export default function WhyChooseUs() {
  return (
    <section
      id="why-us"
      className="py-20 md:py-28 bg-accent/40"
      data-testid="why-us-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl mb-14">
          <p className="eyebrow" data-testid="why-overline">Why Choose Us</p>
          <h2
            className="mt-4 font-headings text-3xl md:text-4xl text-foreground"
            data-testid="why-heading"
          >
            A venue planned around every family's needs.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-border">
          {WHY_CHOOSE_US.map((item, i) => {
            const Icon = ICONS[i] || MapPin;
            return (
              <div
                key={item.title}
                className="bg-background p-8 md:p-10 flex flex-col gap-5 hover:bg-accent/60 transition-colors"
                data-testid={`why-card-${i}`}
              >
                <div className="w-11 h-11 rounded-sm border border-secondary/50 text-secondary flex items-center justify-center">
                  <Icon size={20} strokeWidth={1.5} />
                </div>
                <h3 className="font-headings text-xl md:text-2xl text-primary">
                  {item.title}
                </h3>
                <p className="font-body text-base text-foreground/75 leading-relaxed">
                  {item.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
